import {ReactElement, Suspense} from 'react';
import type {Product} from '@shopify/hydrogen/storefront-api-types';
import {JudgemePreviewBadgeClient} from '@judgeme/shopify-hydrogen';
import { useMobile } from '~/hooks';
import clsx from 'clsx';

interface Props {
  product: Product;
}

export function ProductReview({product}: Props): ReactElement {
  const isMobile = useMobile()
  return (
    <Suspense>
      <div className={clsx(isMobile ? "" : "text-sm", "product-review")}>
        {product?.id && (
          <JudgemePreviewBadgeClient id={product.id} template={''} />
        )}
      </div>
    </Suspense>
  );
}
